import { styled } from "@mui/material";
import { editorName } from "../classes.js";
const Root = styled("div", {
  name: editorName,
  slot: "Root",
  overridesResolver: (_, styles) => styles.root,
  shouldForwardProp: (prop) => !["ownerState", "cssRules", "error", "sx"].includes(prop.toString())
})(({ cssRules }) => ({
  display: "flex",
  flexDirection: "column",
  ...cssRules
}));
export {
  Root
};
//# sourceMappingURL=Root.js.map
